import React, { useState } from "react";
import { minutesToHrMin, StampTo24hr, StampToDate } from "../../../../Utils/utils";
import { FaClock, FaPlane, FaPlaneSlash } from "react-icons/fa";
import BookingStatus from "../Components/flightBookingStatus";
import ViewBooking from "../ViewBooking";
import ViewApproval from "../../../Approval/ViewApproval";
import ViewRequest from "../../Request/ViewRequest";

function FlightBooking({ id, bookingId, date, airlineCode, flightNumber, duration, departureCode, cabinClass, departureTime, arrivalCode, arrivalTime, type, status, approvalRequest, adminRequest, returnDate, onReload = () => {} }) {
	const [BookingId, setBookingId] = useState();
	const [ApprovalId, setApprovalId] = useState();
	const [RequestId, setRequestId] = useState();

	const openBooking = () => {
		if (approvalRequest) {
			setApprovalId(id);
		} else if (adminRequest) {
			setRequestId(id);
		} else {
			setBookingId(bookingId);
		}
	};

	return (
		<>
			<div onClick={openBooking} className="overflow-hidden border shadow-sm cursor-pointer rounded-xl bg-canvas w-full min-w-0 hover:bg-light">
				<div className="p-4">
					<div className="flex items-start justify-between">
						<div className="align-center">
							<img src={`https://cdn.travelwings.com/globalassets/images/${airlineCode?.toUpperCase()}.jpg`} alt={airlineCode} className="w-6 h-6 mr-2 rounded-full" />
							<div className="text-xs text-secondary whitespace-nowrap">
								{airlineCode}-{flightNumber}
							</div>
						</div>
						<div className="text-xs font-bold">{StampToDate(departureTime)}</div>
					</div>
					<div className="mt-3 grid grid-cols-[auto_minmax(0,1fr)_auto] items-center gap-x-3 sm:gap-x-4">
						<div className="min-w-0">
							<div className="font-bold whitespace-nowrap leading-5">{departureCode}</div>
							<div className="text-xs text-secondary whitespace-nowrap">{StampTo24hr(departureTime)}</div>
						</div>
						<div className="min-w-0">
							<div className="w-full">
								<div className="flex items-center">
									<div className="w-2 h-2 border rounded-full border-dark" />
									<div className="min-w-0 flex-1 border-t border-dotted border-dark" />
									{status === "BOOKED" ? <FaPlane /> : status === "FAILED" || status === "CANCELLED" || status === "REFUNDED" || status === "REJECTED" ? <FaPlaneSlash /> : status === "PENDING" ? <FaClock /> : <></>}
									{type === "roundtrip" &&
										(status === "BOOKED" ? (
											<FaPlane className="ml-3 sm:ml-10 rotate-180" />
										) : status === "FAILED" || status === "CANCELLED" || status === "REFUNDED" ? (
											<FaPlaneSlash className="ml-3 sm:ml-6 rotate-180 opacity-50" />
										) : (
											<></>
										))}
									<div className="min-w-0 flex-1 border-t border-dotted border-dark" />
									<div className="w-2 h-2 border rounded-full border-dark" />
								</div>
								<div className="mt-2 text-xs text-center whitespace-nowrap">{minutesToHrMin(duration)}</div>
							</div>
						</div>
						<div className="min-w-0 text-right">
							<div className="font-bold whitespace-nowrap leading-5">{arrivalCode}</div>
							<div className="text-xs text-secondary whitespace-nowrap">{StampTo24hr(arrivalTime)}</div>
						</div>
					</div>
				</div>
				{status && <BookingStatus booking={{ id, date, cabinClass, departureCode, departureTime, arrivalCode, type, status, approvalRequest, adminRequest, returnDate }} />}
			</div>
			<ViewBooking id={BookingId} type="flight" onClose={() => setBookingId()} onReload={onReload} />
			<ViewApproval readOnly approvalId={ApprovalId} onClose={() => setApprovalId()} onReload={onReload} />
			<ViewRequest requestId={RequestId} onClose={() => setRequestId()} onReload={onReload} />
		</>
	);
}

export default FlightBooking;
